import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import PacketInventoryHistory from "./PacketHistory/PacketInventoryHistory";
import PacketAllocation from "./PacketInventoryAllocation/PacketAllocation";
import PacketInventoryHoAllocation from "./PacketInventoryHoAllocation/PacketInventoryHoAllocation";
import PacketDamage from "./PacketDamage/PacketDamage";
function TabPanel(props) {
  const { children, value, index, ...other } = props;


  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any,
  value: PropTypes.any,
};
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
   // display: "flex",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    // width: "14%",
    "& .MuiTabs-indicator": {
      display: "none"
    }
  
  },
  tabPanels: {
    width: "86%",
  },
  Container: {
    marginTop:"20px",
    '& .MuiBox-root':{
      padding:"0px",
    }
  }
}));
const PacketInventory = ({classesChild, featureFlagState}) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation="horizontal"
        variant="scrollable"
        value={value}
        onChange={handleChange}
      >
        <Tab label="Ho Inventory" {...a11yProps(0)} />
        <Tab label="Packet Allocation" {...a11yProps(1)} />
        <Tab label="Damage Packet" {...a11yProps(2)} />
        <Tab label="Packet History" {...a11yProps(3)} />
      </Tabs>
      <TabPanel value={value} index={0} className={classes.Container}>
        <PacketInventoryHoAllocation classes={classesChild} featureFlagState={featureFlagState}/>
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.Container}>
        <PacketAllocation classes={classesChild} featureFlagState={featureFlagState}/>
      </TabPanel>
      <TabPanel value={value} index={2} className={classes.Container}>
        <PacketDamage classes={classesChild} featureFlagState={featureFlagState}/>
      </TabPanel>
      <TabPanel value={value} index={3} className={classes.Container}>
        <PacketInventoryHistory classes={classesChild} featureFlagState={featureFlagState}/>
      </TabPanel>
    </div>
  );
};

PacketInventory.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  index: PropTypes.any,
  value: PropTypes.any,
};

export default PacketInventory;




